import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommListTable extends Layout {
    sourceMcMessagePosition: DataSource;
    tableMcMessage: Table;
}
